import * as yup from 'yup';

export const emailTemplateFormSchema = yup.object().shape({
  name: yup.string().required().default(''),
  subject: yup.string().required().default(''),
});
